import m from 'mithril';

class ExcelData {
  #excelFile = null; // アップロードされたExcelファイル
  #data = null;
  #headers = [];
  #fetched = false;

  constructor() {
  }

  get excelFile() {
    return this.#excelFile;
  }

  get jsonFileName() {
    if (!this.#excelFile) {
      return "";
    }
    // Excelファイル名から拡張子を除去してJSONファイル名を生成
    const fileName = this.#excelFile.name.replace(/\.[^/.]+$/, "");
    return `${fileName}.json`;
  }

  set excelFile(file) {
    this.#excelFile = file;
  }

  get data() {
    return this.#data;
  }

  get previewData() {
    if (!this.#data || this.#data.length === 0) {
      return [];
    }
    // 最初の10行をプレビューとして返す
    return this.#data.slice(0, 10);
  }

  get headers() {
    return this.#headers;
  }

  get fetched() {
    return this.#fetched;
  }

  parseData() {
    if (!this.#excelFile) {
      throw new Error("Excel file is not set.");
    }
    const fd = new FormData();
    fd.append("file", this.#excelFile);
    m.request({
      method: "POST",
      url: "/api/submit",
      body: fd,
    }).then(data => {
      this.#data = data;
      this.#headers = data.length > 0 ? Object.keys(data[0]).map(header => ({ header: header, selected: true })) : [];
      this.#fetched = this.#data && this.#data.length > 0;
      console.log(this);
    }).catch(err => {
      alert("Excelファイルの処理でエラーが発生しました。: " + err.message);
      console.error("Error parsing Excel file:", err);
      throw err;
    });
  }

  getAsJson() {
    if (!this.#fetched) {
      throw new Error("データが取得されていません。");
    }
    const selectedData = this.#data.map(row => {
      const newRow = {};
      this.#headers.forEach(header => {
        if (header.selected) {
          newRow[header.header] = row[header.header];
        }
      });
      return newRow;
    });
    if (selectedData.length === 0) {
      throw new Error("データがありません。");
    }
    return JSON.stringify(selectedData, null, 2);
  }
}

let _excelData = null;
export function getExcelData() {
  if (!_excelData) {
    _excelData = new ExcelData();
  }
  return _excelData;
}